// extracted by mini-css-extract-plugin
export default {"wrap":"Notice_wrap__5tcW8","line":"Notice_line__e8upN","text":"Notice_text__3VdSj"};